module.exports = {
      id: "sharechat-usage",
      viewBox: "0 0 29.14 29.14",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#sharechat",
      toString: function () {
        return this.url;
      }
    }